import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";

function GoodsReceipt() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [supplierList, setSupplierList] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        receipt_no: "",
        receipt_date: "",
        warehouse: "",
        supplier: "",
        remarks: "",
        status: 1,
        addedby: userName,
        ip_add: ipAddress,
    });
    useEffect(() => {
        getWarehouse();
        getSupplier();
        getGoodsReceipt();
    }, []);
    const getWarehouse = () => {
        axios
            .get(baseUrl + "warehouse/")
            .then((res) => {
                setWarehouseList(res.data);
            });
    };
    const getSupplier = () => {
        axios
            .get(baseUrl + "user-profile/")
            .then((res) => {
                setSupplierList(res.data);
            });
    };
    const getGoodsReceipt = () => {
        setLoading(true);
        axios
            .get(baseUrl + "goods-receipt/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Unable to load goods receipt records.",
                });
            });
    };
    const editGoodsReceipt = async (row) => {

    setEditId(row.id);

    setFormData({
        receipt_no: row.receipt_no,
        receipt_date: row.receipt_date,
        warehouse: row.warehouse.id,
        supplier: row.supplier.id,
        remarks: row.remarks,
        status: row.status,
        addedby: userName,
        ip_add: ipAddress,
    });

    await axios.get(
        baseUrl + `update-goods-receipt/${row.id}/`
    );
};
    const saveGoodsReceipt = () => {

    const data = new FormData();

    data.append("receipt_no", formData.receipt_no);
    data.append("receipt_date", formData.receipt_date);
    data.append("warehouse", formData.warehouse);
    data.append("supplier", formData.supplier);
    data.append("remarks", formData.remarks);
    data.append("status", formData.status);
    data.append("addedby", userName);
    data.append("ip_add", ipAddress);

    setLoading(true);

    const request =
        editId === null
            ? axios.post(baseUrl + "goods-receipt/", data)
            : axios.put(
                  baseUrl + `update-goods-receipt/${editId}/`,
                  data
              );

    request
        .then(() => {

            Swal.fire({
                icon: "success",
                title: "Success",
                text:
                    editId === null
                        ? "Goods Receipt saved successfully."
                        : "Goods Receipt updated successfully.",
            });

            clearForm();
            getGoodsReceipt();

        })
        .catch(() => {

            setLoading(false);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to save Goods Receipt.",
            });

        });
};
    const deleteGoodsReceipt = (id) => {

    Swal.fire({
        title: "Delete Goods Receipt?",
        text: "You won't be able to revert this.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
    }).then((result) => {

        if (result.isConfirmed) {

            setLoading(true);

            axios
                .delete(baseUrl + `update-goods-receipt/${id}/`)
                .then(() => {

                    Swal.fire({
                        icon: "success",
                        title: "Deleted",
                        text: "Goods Receipt deleted successfully.",
                    });

                    getGoodsReceipt();

                })
                .catch(() => {

                    setLoading(false);

                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Unable to delete Goods Receipt.",
                    });

                });

        }

    });

};
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const clearForm = () => {

    setEditId(null);

    setFormData({
        receipt_no: "",
        receipt_date: "",
        warehouse: "",
        supplier: "",
        remarks: "",
        status: 1,
        addedby: userName,
        ip_add: ipAddress,
    });

};
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 80,
        },
        {
            field: "receipt_no",
            headerName: "Receipt No",
            width: 160,
        },
        {
            field: "receipt_date",
            headerName: "Receipt Date",
            width: 140,
        },
        {
            field: "warehouse_name",
            headerName: "Warehouse",
            flex: 1,
            renderCell: (params) => (params.row.warehouse?.warehouse_name)
        },
        {
            field: "supplier_name",
            headerName: "Supplier",
            flex: 1,
            renderCell: (params) => (params.row.supplier?.name)
        },

        {
            field: "remarks",
            headerName: "Remarks",
            flex: 1,
        },
        {
            field: "status",
            headerName: "Status",
            width: 100,
            renderCell: (params) =>
                params.value == 1 ? "Active" : "Inactive",
        },
        {
    field: "action",
    headerName: "Action",
    width: 180,
    sortable: false,
    renderCell: (params) => (
        <>
            <button
                className="btn btn-success btn-sm me-2"
                onClick={() => editGoodsReceipt(params.row)}
            >
                Edit
            </button>

            <button
                className="btn btn-danger btn-sm"
                onClick={() => deleteGoodsReceipt(params.row.id)}
            >
                Delete
            </button>
        </>
    ),
},
    ];
    return (
        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Goods Receipt
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-3 mb-3">

                            <label>Receipt No</label>

                            <input
                                type="text"
                                className="form-control"
                                name="receipt_no"
                                value={formData.receipt_no}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Receipt Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="receipt_date"
                                value={formData.receipt_date}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Warehouse</label>

                            <select
                                className="form-select"
                                name="warehouse"
                                value={formData.warehouse}
                                onChange={handleChange}
                            >

                                <option value="">
                                    Select Warehouse
                                </option>

                                {warehouseList.map((item) => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.warehouse_name}
                                    </option>
                                ))}

                            </select>

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Supplier</label>

                            <select
                                className="form-select"
                                name="supplier"
                                value={formData.supplier}
                                onChange={handleChange}
                            >

                                <option value="">
                                    Select Supplier
                                </option>

                                {supplierList.map((item) => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>
                                ))}

                            </select>

                        </div>

                        <div className="col-md-6 mb-3">

                            <label>Remarks</label>

                            <textarea
                                className="form-control"
                                rows="2"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Status</label>

                            <select
                                className="form-select"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value={1}>Active</option>
                                <option value={0}>Inactive</option>
                            </select>

                        </div>

                        <div className="col-md-12 mt-3">

                            <button
                                className="btn btn-success me-2"
                                onClick={saveGoodsReceipt}
                                disabled={loading}
                            >
                                Save
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </div>
                    <div className="card shadow mt-3">

                        <div className="card-header bg-primary text-white">

                            <h5 className="mb-0">
                                Goods Receipt List
                            </h5>

                        </div>

                        <div className="card-body">

                            <div
                                style={{
                                    height: 600,
                                    width: "100%",
                                }}
                            >

                                <ERPDataGrid
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    getRowId={(row) => row.id}
                                    pageSizeOptions={[
                                        10,
                                        25,
                                        50,
                                        100,
                                    ]}
                                    
                                    disableRowSelectionOnClick
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}
export default GoodsReceipt;